exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-blocks-utils-text-Block{outline:none!important}.galaxy\\:\\:common-canvas-blocks-utils-text-Block,.galaxy\\:\\:common-canvas-blocks-utils-text-Block *{-webkit-user-select:auto!important;-moz-user-select:auto!important;user-select:auto!important}", ""]);

